import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translate } from '../contexts/Language';
import { ErrorMessage } from './Validator';
import { Service } from '../services';
import { Config } from '../config';

export class LimitEdit extends Component {
  static propTypes = {
    Data: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);

    const { Data } = this.props;
    this.state = {
      formData: {
        transferOption: Data.transferOption,
        maxLimit: Data.maxLimit,
        minLimit: Data.minLimit,
      },
      validation: {
        error: false,
        message: '',
      },
    };
  }

  onFormChange(e, key) {
    const { formData } = this.state;

    formData[key] = e.target.value;

    this.setState({
      formData,
    });
  }

  onSave() {
    const { formData } = this.state;

    Config.utilities.loadingFetch();

    Service.TransferOptions.DailyLimitSave(formData).then(response => {
      if (response.error) {
        this.setState({
          validation: {
            error: response.error,
            message: response.message,
          },
        });
      }

      Config.utilities.loadingFetch();
    });
  }

  render() {
    const { formData, validation } = this.state;
    const { Data } = this.props;

    return (
      <div className="col-md-4 mb-4">
        <ErrorMessage Validation={validation} />
        <div className="img-thumbnail p-3">
          <span className="d-block mb-3 limit-logo">
            <img src={`/assets/psp-logo/${(Data.transferOptionLogo || 'defaultlogo.svg')}`} alt="" width="30" className="mb-1 mr-2" />
            {Data.transferOptionTitle}
            {Data.acceptedCurrencies.map(item => (<span key={item} className="badge badge-light m-1">{Translate(item)}</span>))}
          </span>
          <div className="row">
            <div className="form-group input-group-sm col-lg-5 pl-4">
              <label htmlFor="name">Minimum</label>
              <input type="number" id="minimum" name="minimum" className="form-control input-sm" value={formData.minLimit} onChange={e => this.onFormChange(e, 'minLimit')} />
            </div>
            <div className="form-group input-group-sm col-lg-5 pr-4">
              <label htmlFor="name">Maximum</label>
              <input type="number" id="maximum" name="maximum" className="form-control input-sm" value={formData.maxLimit} onChange={e => this.onFormChange(e, 'maxLimit')} />
            </div>
            <div className="col-lg-2">
              <button type="button" className="btn btn-primary float-right mr-2 mt-4" onClick={() => this.onSave()}>Save</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
